import React from "react";
import PropTypes from "prop-types";
import { FlaskConical, Check, ArrowUpRight } from "lucide-react";

/**
 * Shown to users without the Ultra/Enterprise tier when they hit any
 * /lab/* route. Mirrors spec §2.
 */
const LabUpgradeSplash = ({ currentTier, onUpgrade, onLearnMore }) => (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-indigo-50 dark:from-slate-950 dark:via-slate-900 dark:to-indigo-950 flex items-center justify-center p-6">
        <div className="max-w-xl w-full bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xl p-10">
            <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-xl bg-indigo-100 dark:bg-indigo-900/40 flex items-center justify-center">
                    <FlaskConical className="w-6 h-6 text-indigo-600 dark:text-indigo-400" />
                </div>
                <div>
                    <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50">The Lab</h1>
                    <p className="text-sm text-slate-500 dark:text-slate-400">
                        Run autonomous-driving experiments on our hosted models.
                    </p>
                </div>
            </div>

            <p className="text-sm text-slate-600 dark:text-slate-300 mb-6">
                Available on <span className="font-semibold">Ultra</span> and{" "}
                <span className="font-semibold">Enterprise</span> plans.
                {currentTier ? (
                    <>
                        {" "}
                        Your current plan: <span className="font-mono text-xs px-1.5 py-0.5 rounded bg-slate-100 dark:bg-slate-800">{currentTier}</span>.
                    </>
                ) : null}
            </p>

            <ul className="space-y-2 mb-8">
                {[
                    "Submit experiments via YAML or guided form",
                    "Watch each step run in real time",
                    "Get auto-generated next-experiment recommendations",
                    "Email reports + delta-vs-baseline scoring",
                ].map((feature) => (
                    <li key={feature} className="flex items-start gap-2 text-sm text-slate-700 dark:text-slate-300">
                        <Check className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" />
                        <span>{feature}</span>
                    </li>
                ))}
            </ul>

            <div className="flex gap-3">
                <button
                    onClick={onUpgrade}
                    className="flex-1 inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white font-medium transition"
                >
                    Upgrade to Ultra
                    <ArrowUpRight className="w-4 h-4" />
                </button>
                <button
                    onClick={onLearnMore}
                    className="inline-flex items-center justify-center px-5 py-2.5 rounded-lg border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 font-medium transition"
                >
                    Learn more
                </button>
            </div>
        </div>
    </div>
);

LabUpgradeSplash.propTypes = {
    currentTier: PropTypes.string,
    onUpgrade: PropTypes.func,
    onLearnMore: PropTypes.func,
};

LabUpgradeSplash.defaultProps = {
    currentTier: null,
    onUpgrade: () => { window.location.href = "/billing"; },
    onLearnMore: () => { window.location.href = "/lab/upgrade"; },
};

export default LabUpgradeSplash;
